module.exports = __webpack_public_path__ + "static/doors-bc1d4da6ef0636601626692415e690b8.jpg";